(() => {
  const wrapperSelector = '[data-product-card-carousel]';
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  function getScroller(element) {
    const wrapper = element.closest(wrapperSelector);

    return wrapper
      ? wrapper.querySelector('.native-swipe-carousel')
      : null;
  }

  /*
   * Zentrale Steuerung der Vor- und Zurück-Buttons.
   * Funktioniert auch bei nachgeladenen Suchergebnissen.
   */
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const button = event.target.closest('[data-carousel-direction]');

    if (!button) {
      return;
    }

    const scroller = getScroller(button);

    if (!scroller) {
      return;
    }

    const maxScroll = scroller.scrollWidth - scroller.clientWidth;

    if (maxScroll <= 1) {
      return;
    }

    const currentScroll = scroller.scrollLeft;
    const direction = button.dataset.carouselDirection;
    let targetScroll = currentScroll;

    if (direction === 'next') {
      targetScroll =
        currentScroll >= maxScroll - 5
          ? 0
          : Math.min(currentScroll + scroller.clientWidth, maxScroll);
    }

    if (direction === 'previous') {
      targetScroll =
        currentScroll <= 5
          ? maxScroll
          : Math.max(currentScroll - scroller.clientWidth, 0);
    }

    scroller.scrollTo({
      left: targetScroll,
      behavior: reducedMotion.matches ? 'auto' : 'smooth'
    });
  });

  /*
   * Einmaliger, weich animierter Peek-Hinweis bei der ersten Produktkarte.
   * Er startet erst, wenn die Karte tatsächlich sichtbar ist.
   */
  function startPeek(wrapper) {
    if (wrapper.dataset.carouselPeeked === 'true') {
      return;
    }

    wrapper.dataset.carouselPeeked = 'true';

    const scroller = wrapper.querySelector('.native-swipe-carousel');

    if (!scroller || reducedMotion.matches) {
      return;
    }

    const maxScroll = scroller.scrollWidth - scroller.clientWidth;

    if (maxScroll <= 1) {
      return;
    }

    let finished = false;
    let animationFrame = 0;
    const timers = [];

    function removeInteractionListeners() {
      wrapper.removeEventListener('pointerdown', cancelPeek);
      wrapper.removeEventListener('wheel', cancelPeek);
      wrapper.removeEventListener('keydown', cancelPeek);
    }

    function finishPeek() {
      if (finished) {
        return;
      }

      finished = true;
      scroller.classList.remove('is-peeking');
      removeInteractionListeners();
    }

    function cancelPeek() {
      if (finished) {
        return;
      }

      finished = true;

      timers.forEach((timer) => window.clearTimeout(timer));

      if (animationFrame) {
        window.cancelAnimationFrame(animationFrame);
      }

      scroller.classList.remove('is-peeking');
      scroller.scrollLeft = 0;
      removeInteractionListeners();
    }

    function animateScroll(targetScroll, duration, onComplete) {
      const startScroll = scroller.scrollLeft;
      const distance = targetScroll - startScroll;
      const startTime = window.performance.now();

      function step(currentTime) {
        if (finished) {
          return;
        }

        const progress = Math.min((currentTime - startTime) / duration, 1);
        const easedProgress = -(Math.cos(Math.PI * progress) - 1) / 2;

        scroller.scrollLeft = startScroll + distance * easedProgress;

        if (progress < 1) {
          animationFrame = window.requestAnimationFrame(step);
          return;
        }

        animationFrame = 0;
        onComplete();
      }

      animationFrame = window.requestAnimationFrame(step);
    }

    wrapper.addEventListener('pointerdown', cancelPeek, {
      passive: true
    });

    wrapper.addEventListener('wheel', cancelPeek, {
      passive: true
    });

    wrapper.addEventListener('keydown', cancelPeek);

    timers.push(
      window.setTimeout(() => {
        if (finished) {
          return;
        }

        scroller.classList.add('is-peeking');

        animateScroll(
          Math.min(scroller.clientWidth * 0.55, maxScroll),
          1050,
          () => {
            timers.push(
              window.setTimeout(() => {
                animateScroll(0, 1150, finishPeek);
              }, 450)
            );
          }
        );
      }, 1500)
    );
  }

  const peekObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                return;
              }

              observer.unobserve(entry.target);
              startPeek(entry.target);
            });
          },
          {
            threshold: 0.65
          }
        )
      : null;

  function registerPeekCarousels(root = document) {
    const wrappers = root.querySelectorAll(
      '[data-carousel-peek]:not([data-carousel-peek-registered])'
    );

    wrappers.forEach((wrapper) => {
      wrapper.dataset.carouselPeekRegistered = 'true';

      if (peekObserver) {
        peekObserver.observe(wrapper);
      } else {
        startPeek(wrapper);
      }
    });
  }

  registerPeekCarousels();

  /*
   * Unterstützt neu geladene Abschnitte im Shopify-Theme-Editor.
   */
  document.addEventListener('shopify:section:load', (event) => {
    registerPeekCarousels(event.target);
  });
})();